import React, { useState, useEffect } from 'react';
import { IconBell, IconRefresh } from './Icons';
import { db } from '../firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';

const PAGE_TITLES = {
  dashboard: { title: 'डॅशबोर्ड | Dashboard', subtitle: 'Smart Sangola – Sangola, Maharashtra' },
  orders:    { title: 'ऑर्डर्स | Orders', subtitle: 'All incoming & delivered orders' },
  users:     { title: 'कस्टमर्स | Customers', subtitle: 'Registered customer base' },
  shops:     { title: 'दुकाने | Shops', subtitle: 'Partner shops in Sangola network' },
  delivery:  { title: 'डिलिव्हरी बॉय', subtitle: 'Active delivery fleet' },
  tracking:  { title: 'Live Tracking 📍', subtitle: 'Real-time delivery location' },
  reports:   { title: 'कमाई अहवाल | Reports', subtitle: 'Earnings & analytics' },
  services:  { title: 'सेवा | Services', subtitle: 'Labour & professional services' },
};

export default function Header({ activePage, logout, activeOrdersCount = 0 }) {
  const [now] = useState(new Date());
  const info = PAGE_TITLES[activePage] || PAGE_TITLES.dashboard;

  const timeStr = now.toLocaleTimeString('mr-IN', { hour: '2-digit', minute: '2-digit' });
  const dateStr = now.toLocaleDateString('mr-IN', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });

  return (
    <header className="header">
      <div>
        <div className="header-title">{info.title}</div>
        <div className="header-subtitle">{info.subtitle}</div>
      </div>

      <div className="header-right">
        {/* Live time */}
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: 15, fontWeight: 700 }}>{timeStr}</div>
          <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{dateStr}</div>
        </div>

        {/* Active orders counter */}
        <div className="header-stat">
          <div>
            <div className="label">Active Orders</div>
            <div className="value">{activeOrdersCount}</div>
          </div>
        </div>

        {/* Notification */}
        <button className="notif-btn">
          <IconBell size={17} />
          <span className="notif-dot" />
        </button>
      </div>
    </header>
  );
}
